(function waitForProduct() {

      if (!window._app?.data) {
        return setTimeout(waitForProduct, 100);
      }

      const product = window._app.data.product;
      if (!product) return;
      if (product.available) return;

      const product_form = document.querySelector(".ProductDetails");


      const email_form = document.createElement("div");
      email_form.classList.add("out-of-stock");
      email_form.setAttribute("style", "border: 1px solid; padding: 10px; margin-top: 30px; background: #fff;")
      email_form.innerHTML = `
      <div>
        <h3 style="margin-bottom:20px;">Be notified when back in stock?</h3>
        <div class="signup" style="display:flex;gap:10px;">
          <div class="input" style="border-bottom: 1.25px solid; font-size: 12px; margin-bottom: 15px; padding-bottom: 12px; position: relative; width: 100%;">
            <label
              ><input type="email" placeholder="EMAIL" required="required" style="width:100%;"/>
              </label
            >
          </div>
          <div style="position: relative">
            <button style="align-items: center;display: flex ; font-size: 12px; height: 31px; justify-content: center; line-height: 1; padding-top: 2px; right: 0; top: -2.5px; width: 74px;">SUBMIT</button>
          </div>
        </div>
      </div>
      <div class="disclaimer">
        <p>
          By joining, you agree to receive email and/or text message marketing of
          the contacts provided. Unsubscribe at any time. Consent is not a condition
          of purchase. View our
          <a href="/policies/privacy-policy" target="_blank" title="Privacy Policy"
            >Privacy Policy</a
          >
          and
          <a
            href="/policies/terms-of-service"
            target="_blank"
            title="Terms of Service"
            >Terms of Service</a
          >.
        </p>
      </div>
      `;
    

        const email_input = email_form.querySelector("input");
        const email_submit = email_form.querySelector("button");

        email_submit.addEventListener("click", function() {
            const email = email_input.value;
            if (!email) return;
            const options = {
                method: 'POST',
                headers: {
                    accept: 'application/vnd.api+json',
                    revision: '2025-01-15',
                    'content-type': 'application/vnd.api+json'
                },
                body: JSON.stringify({
                    "data": {
                        "type": "back-in-stock-subscription",
                        "attributes": {
                            "channels": [
                                "EMAIL",
                            ],
                            "profile": {
                                "data": {
                                    "type": "profile",
                                    "attributes": {
                                        "email": email,
                                    }
                                }
                            }
                        },
                        "relationships": {
                            "variant": {
                                "data": {
                                    "type": "catalog-variant",
                                    "id": `$shopify:::$default:::${window._app.data.product.variants[0].id}`
                                }
                            }
                        }
                    }
                })
            };

          console.log(options)
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=PyfYit', options)
            .then(res => res.text())
            .then(res => {
              email_form.innerHTML = `<div><p>Success! We'll be in touch.</p></div>`
              
            })
            .catch(err => console.error(err));
                
        });

      product_form.after(email_form);


    })();